import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from '../QuizData';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-preferencequiz',
  templateUrl: './preferencequiz.component.html',
  styleUrls: ['./preferencequiz.component.css']
})
export class PreferencequizComponent implements OnInit {

  preferencequizForm : FormGroup;
  failedMessage : string;
  submitted = false;
  successMessage: string;

  smartphone_usage = [];


  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private cookie: CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit(): void {

    this.preferencequizForm  =  this.formBuilder.group({

      preference_expert: ['', Validators.required],
      preference_health_education: ['', Validators.required],
      smartphone_usage: new FormArray([], minSelectedCheckboxes(1)),

    });

    this.smartphone_usage = this.getSmartphoneUsage();
    this.addSmartphoneUsageCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });

  }

  private addSmartphoneUsageCheckboxes() {
    this.smartphone_usage.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.preferencequizForm.controls.smartphone_usage as FormArray).push(control);
    });
  }

  get fmBuilder() { return this.preferencequizForm.controls; }

  reset(){
    this.preferencequizForm.reset({PersonalData: new QuizData()});
  }


  getFormControl(name:any) {
    return this.preferencequizForm.get(name);
  }

  
  getSmartphoneUsage(){
    return [
      { value: 1, id: 'phone_calls', name: 'For phone calls' },
      { value: 2, id: 'texting', name: 'For texting' },
      { value: 3, id: 'apps', name: 'For apps and online browsing' },
      { value: 4, id: 'watch_videos', name: 'To watch videos or to video chat' },
      { value: 5, id: 'bad_data_plan', name: 'I do not have a good plan or internet connection to watch videos or video chat' }
    ]
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.preferencequizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.preferencequizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

   btnclick(){
    const result: QuizData = Object.assign({}, this.preferencequizForm.value);
    let fromResult = Object.assign({}, result);
    
    this.submitted = true;

    console.log("about to check form validation");
    // stop here if form is invalid
    if (this.preferencequizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
  
    const selectedSmartphoneUsage = this.preferencequizForm.value.smartphone_usage
      .map((v, i) => v ? this.smartphone_usage[i].value : null)
      .filter(v => v !== null);
    
    var userInfo = new QuizData()
    userInfo.smartphone_usage = selectedSmartphoneUsage;
    userInfo.preference_expert = String(this.preferencequizForm.get(['preference_expert']).value);
    userInfo.preference_health_education = String(this.preferencequizForm.get(['preference_health_education']).value);
    
    console.log(userInfo.score)
    this._bkoffService.setPreferenceQuizData(userInfo);

    console.log("btnclick registered")
    this.router.navigateByUrl('/quiz8');   
  };

}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
